import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import TrialActivationNextStepsModal from './TrialActivationNextStepsModal';
import ActivationSuccessModal from 'ui-addon-upgrades/_core/common/components/activation/ActivationSuccessModal';
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
import { NEXT_STEPS_SURVEY_API_NAMES, NEXT_STEPS_SURVEY_UPGRADE_PRODUCTS } from 'ui-addon-upgrades/_core/common/constants/trials';
const SUCCESS_MODAL_TYPES = {
  INITIAL_SUCCESS: 'INITIAL_SUCCESS',
  NEXT_STEPS_SURVEY: 'NEXT_STEPS_SURVEY'
};

const TrialActivationSuccessContainer = ({
  hideBackground,
  header,
  subText,
  ctaText,
  onSuccess,
  upgradeData,
  shouldHideSurvey,
  showIllustration,
  showTrialLoadingState,
  canViewNewSeats
}) => {
  const [successModalType, setSuccessModalType] = useState(SUCCESS_MODAL_TYPES.INITIAL_SUCCESS);

  const maybeShowNextStepsSurvey = () => {
    const {
      upgradeProduct,
      apiName
    } = upgradeData;
    const eligibleForNewSeats = canViewNewSeats && apiName;
    const nextStepsIncludesProduct = eligibleForNewSeats ? NEXT_STEPS_SURVEY_API_NAMES.includes(apiName) : NEXT_STEPS_SURVEY_UPGRADE_PRODUCTS.includes(upgradeProduct);
    const shouldShowNextStepsSurvey = nextStepsIncludesProduct && !shouldHideSurvey;

    if (shouldShowNextStepsSurvey) {
      setSuccessModalType(SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY);
    } else if (onSuccess) {
      onSuccess();
    }
  };

  switch (successModalType) {
    case SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY:
      return /*#__PURE__*/_jsx(TrialActivationNextStepsModal, {
        upgradeData: upgradeData,
        canViewNewSeats: canViewNewSeats
      });

    case SUCCESS_MODAL_TYPES.INITIAL_SUCCESS:
      return /*#__PURE__*/_jsx(ActivationSuccessModal, {
        type: sourceKeys.TRIAL,
        hideBackground: hideBackground,
        header: header,
        subText: subText,
        ctaText: ctaText,
        showIllustration: showIllustration,
        showTrialLoadingState: showTrialLoadingState,
        onSuccess: maybeShowNextStepsSurvey,
        upgradeData: upgradeData,
        canViewNewSeats: canViewNewSeats
      });

    default:
      return null;
  }
};

TrialActivationSuccessContainer.propTypes = Object.assign({
  hideBackground: PropTypes.bool.isRequired,
  header: PropTypes.node,
  subText: PropTypes.node,
  ctaText: PropTypes.node,
  showIllustration: PropTypes.bool,
  shouldHideSurvey: PropTypes.bool,
  onSuccess: PropTypes.func,
  showTrialLoadingState: PropTypes.bool
}, upgradeDataPropsInterface);
export default TrialActivationSuccessContainer;